module.exports = {
          srcSet: __webpack_public_path__ + "e414d0e8.jpg"+" 700w"+","+__webpack_public_path__ + "109245d0.jpg"+" 1400w"+","+__webpack_public_path__ + "4585bb84.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "e414d0e8.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "109245d0.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "4585bb84.jpg",width: 2048,height: 1536}],
          src: __webpack_public_path__ + "e414d0e8.jpg",
          toString:function(){return __webpack_public_path__ + "e414d0e8.jpg"},
          
          width: 700,
          height: 525
        }